import { useContext } from 'react';
import { fetchAudio } from '../hooks/audioService';
import VideoContext from '../context/VideoContext';
import AudioContext from '../context/AudioContext';
import VocalInterfaceContext from '../context/VocalInterfaceContext';

interface hookProps {
  urlId: string;
}

const useAudioDescBtn = ({ urlId }: hookProps) => {
  const { setVideoSrc, setIsVideo } = useContext(VideoContext);
  const { audioRef } = useContext(AudioContext);  
  const { setIsVocalInterface } = useContext(VocalInterfaceContext);

  const handleAudio = async () => {
    try {
      const data = await fetchAudio(urlId);
      setIsVocalInterface(true);
      if (data.includes('.mp4')) {
        setVideoSrc(data);
        setIsVideo(true);
      } else {
        if (audioRef && audioRef.current) {
          audioRef.current.src = data;
          audioRef.current.currentTime = 0;
          audioRef.current.play();
        }
      }
    } catch(error:  any) {
      console.error(error.message);
    }
  };

  return handleAudio;
};

export default useAudioDescBtn;